import React, { Component } from 'react';
import { renderIntoContainer } from 'react/root/containerRoot';
import LadderSuspense from "../react/elements/LadderSuspense.jsx";

const BlogEdit = React.lazy(() => import(/* webpackChunkName: "BlogEdit" */ '../react/posts/BlogEdit'));

$(function() {

	const blogEdit = document.getElementById('blog_edit');
	if(blogEdit) {
		renderIntoContainer(
			<LadderSuspense>
				<BlogEdit
					postId={blogEdit.getAttribute('data-id')}
				/>
			</LadderSuspense>
			,
			blogEdit
		);
	}
});